import { gql } from "@apollo/client";

const GET_CHALLENGES = gql`
  query challenges(
    $filters: ChallengeFilter
    $profileId: ID
    $first: Int
    $last: Int
    $after: String
    $before: String
    $paginationInfo: PaginationInfo
    $includeLastImportedAt: Boolean = false
  ) {
    challenges(
      filters: $filters
      profileId: $profileId
      first: $first
      last: $last
      after: $after
      before: $before
      paginationInfo: $paginationInfo
    ) {
      totalCount
      currentPage
      perPage
      lastImportedAt @include(if: $includeLastImportedAt)
      nodes {
        id
        uuid
        serviceId
        icon
        name
        privateName
        description
        maxScore
        timeLimit
        published
        testUrl
        inviteUrl
        tasks
        type
        tasksCount
        responsesCount
        createdAt
        publishedAt
        archivedAt
        challengeResponse {
          completedAt
          feedbackUrl
          id
          maxScore
          profileId
          reportUrl
          score
          serviceId
          sessionUrl
          startedAt
          status
          tasks
          testUrl
          type
          uuid
        }
        skills {
          id
          name
        }
        disciplines {
          id
          name
        }
        types {
          id
          name
        }
        challengeItems {
          id
          type
          serviceId
          title
          summary
          instructions
          metadata
          payload
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          id
        }
      }
    }
  }
`;

const IMPORT_CHALLENGES = gql`
  mutation importChallenges($input: ImportChallengesInput!) {
    importChallenges(input: $input) {
      success
    }
  }
`;

export { GET_CHALLENGES, IMPORT_CHALLENGES };
